<template>
	<div>
		<v-row no-gutters>
			<span class="font-weight-bold">受注No</span>
			<span class="font-weight-bold">{{ order_confirmation.matter_id }}</span>
		</v-row>

		<v-text-field
			v-if="action == 'edit'"
			v-model="order_confirmation.reason"
			:rules="[rules.required]"
			class="mt-4"
			label="変更理由(必須)"
			outlined
			dense
		/>

		<v-radio-group
			label="手配可否"
			v-model="order_confirmation.arrangement_availability"
			class="mt-4"
			dense
			row
		>
			<v-radio label="手配可" :value="true" class="mx-2" />
			<v-radio label="手配否" :value="false" class="mx-2" />
		</v-radio-group>

		<v-row no-gutters align="center">
			<v-col cols="12" lg="6">
				<v-combobox
					ref="user_combobox"
					v-model="order_confirmation.created_user"
					:class="$vuetify.breakpoint.xs ? '' : 'mr-1'"
					:items="users"
					:rules="[rules.required]"
					:hint="userHint"
					:label="action == 'new' ? '作成者を検索(必須)' : '変更者を検索(必須)'"
					outlined
					dense
					item-text="full_name"
					item-value="id"
					@keyup="setSearchUsers"
					@change="changeUser"
				/>
			</v-col>

			<v-col cols="12" lg="6">
				<v-select
					v-model="order_confirmation.source_of_base_material"
					label="手配元(ライニング製品の母材)"
					:class="$vuetify.breakpoint.xs ? 'mt-4' : ''"
					outlined
					required
					dense
					:items="items.source_of_base_materials"
					item-text="name"
					item-value="value"
				>
				</v-select>
			</v-col>

			<v-col cols="12" lg="6">
				<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							:class="$vuetify.breakpoint.xs ? 'mt-4' : 'mr-1'"
							v-model="order_confirmation.scheduled_date_of_payment"
							label="支給予定日"
							required
							readonly
							outlined
							dense
							v-bind="attrs"
							v-on="on"
						/>
					</template>
					<v-date-picker
						v-model="order_confirmation.scheduled_date_of_payment"
						no-title
						locale="ja-JP"
					/>
				</v-menu>
			</v-col>

			<v-col cols="12" lg="6">
				<v-menu close-on-content-click transition="scale-transition" offset-y min-width="auto">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							:class="$vuetify.breakpoint.xs ? 'mt-4' : ''"
							v-model="order_confirmation.scheduled_date_of_approval"
							label="製品の承認予定日"
							required
							readonly
							outlined
							dense
							v-bind="attrs"
							v-on="on"
						/>
					</template>
					<v-date-picker
						v-model="order_confirmation.scheduled_date_of_approval"
						no-title
						locale="ja-JP"
					/>
				</v-menu>
			</v-col>

			<v-col cols="12">
				<v-radio-group
					label="塗装区分"
					v-model="order_confirmation.exists_coating"
					class="mt-4"
					dense
					row
				>
					<v-radio label="有" :value="true" class="mx-2" />
					<v-radio label="無" :value="false" class="mx-2" />
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-textarea
					v-model="order_confirmation.coating_content"
					class="mt-4"
					label="補足"
					outlined
					dense
				></v-textarea>
			</v-col>

			<v-col cols="12">
				<v-radio-group
					label="工程写真区分"
					v-model="order_confirmation.exists_process_photo"
					class="mt-4"
					dense
					row
				>
					<v-radio label="有" :value="true" class="mx-2" />
					<v-radio label="無" :value="false" class="mx-2" />
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-textarea
					v-model="order_confirmation.process_photo_content"
					class="mt-4"
					label="補足"
					outlined
					dense
				></v-textarea>
			</v-col>

			<v-col cols="12">
				<v-radio-group
					label="水協検査区分"
					v-model="order_confirmation.exists_water_works"
					class="mt-4"
					dense
					row
				>
					<v-radio label="有" :value="true" class="mx-2" />
					<v-radio label="無" :value="false" class="mx-2" />
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-textarea
					v-model.trim="order_confirmation.water_works_content"
					class="mt-4"
					label="補足"
					outlined
					dense
				></v-textarea>
			</v-col>

			<v-col cols="12">
				<v-radio-group
					label="立会区分"
					v-model="order_confirmation.exists_witness"
					class="mt-4"
					dense
					row
				>
					<v-radio label="有" :value="true" class="mx-2" />
					<v-radio label="無" :value="false" class="mx-2" />
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-textarea
					v-model.trim="order_confirmation.witness_content"
					class="mt-4"
					label="補足"
					outlined
					dense
				></v-textarea>
			</v-col>

			<v-col cols="12">
				<v-radio-group
					label="梱包指定区分"
					v-model="order_confirmation.exists_packaging"
					class="mt-4"
					dense
					row
				>
					<v-radio label="有" :value="true" class="mx-2" />
					<v-radio label="無" :value="false" class="mx-2" />
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-textarea
					v-model.trim="order_confirmation.packaging_content"
					class="mt-4"
					label="補足"
					outlined
					dense
				></v-textarea>
			</v-col>

			<v-col cols="12">
				<v-radio-group
					label="出荷時添付書類"
					v-model="order_confirmation.exists_attached_file"
					class="mt-4"
					dense
					row
				>
					<v-radio label="有" :value="true" class="mx-2" />
					<v-radio label="無" :value="false" class="mx-2" />
				</v-radio-group>
			</v-col>

			<v-col cols="12">
				<v-combobox
					ref="combobox"
					v-model="order_confirmation.attached_file_content"
					class="mt-4"
					:items="items.attached_file_items"
					label="出荷時添付書類の内容を選択または入力"
					outlined
					dense
				/>
			</v-col>
		</v-row>

		<v-select
			v-model="order_confirmation.source_of_transport"
			label="手配元(輸送)"
			class="mt-4"
			outlined
			required
			dense
			:items="items.source_of_transports"
			item-text="name"
			item-value="value"
		>
		</v-select>

		<v-combobox
			ref="combobox"
			v-model="order_confirmation.transport"
			:items="items.transports"
			label="輸送方法を選択または入力"
			outlined
			dense
		/>

		<v-textarea
			v-model.trim="order_confirmation.content"
			class="mt-4"
			label="生産企画部記載欄"
			outlined
			dense
		></v-textarea>

		<v-radio-group
			label="見積原価の有無"
			v-model="order_confirmation.exists_quotation_cost"
			class="mt-4"
			dense
			row
		>
			<v-radio label="有" :value="true" class="mx-2" />
			<v-radio label="無" :value="false" class="mx-2" />
		</v-radio-group>

		<v-radio-group
			label="受注金額入力の有無"
			v-model="order_confirmation.exists_order_amount"
			class="mt-4"
			dense
			row
		>
			<v-radio label="有" :value="true" class="mx-2" />
			<v-radio label="無" :value="false" class="mx-2" />
		</v-radio-group>

		<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
			<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
			添付ファイルを追加
			<input type="file" class="d-none" ref="uploadFile" @change="addFiles($event)" multiple />
		</v-btn>

		<div class="file-area mt-2">
			<span v-if="allFiles < 1" class="filename">選択されていません</span>
			<template v-else>
				<v-chip
					class="ma-1 mt-2"
					close
					label
					outlined
					color="primary"
					@click:close="removeFile(i)"
					v-for="(file, i) in order_confirmation.file_url"
					:key="file.name"
				>
					<v-icon class="mr-1">mdi-paperclip</v-icon>
					{{ file.name }}
				</v-chip>
			</template>
		</div>

		<v-row class="ma-0 pa-0" justify="center">
			<v-btn
				class="ma-1 white--text font-weight-bold"
				@click="sendParent"
				dense
				color="secondary"
				>{{ btnText }}</v-btn
			>
		</v-row>
	</div>
</template>

<script>
import axios from "axios"

import rules from "../../../helper/rules"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"

export default {
	components: {},
	props: {
		action: {
			type: String,
			required: false,
		},
		btnText: {
			type: String,
			required: true,
		},
		action: {
			type: String,
			required: false,
		},
		order_confirmation: {
			reason: {
				type: String,
				required: false,
			},
			matter_id: {
				type: String,
				required: true,
				default: "",
			},
			source_of_base_material: {
				type: String,
				required: false,
			},
			scheduled_date_of_payment: {
				type: Date,
				required: false,
			},
			scheduled_date_of_approval: {
				type: Date,
				required: false,
			},
			exists_coating: {
				type: Boolean,
				required: false,
				default: false,
			},
			coating_content: {
				type: String,
				required: false,
			},
			exists_process_photo: {
				type: Boolean,
				required: false,
				default: false,
			},
			process_photo_content: {
				type: String,
				required: false,
			},
			exists_water_works: {
				type: Boolean,
				required: false,
				default: false,
			},
			water_works_content: {
				type: String,
				required: false,
			},
			exists_witness: {
				type: String,
				required: false,
				default: false,
			},

			witness_content: {
				type: String,
				required: false,
			},
			exists_packaging: {
				type: Boolean,
				required: false,
				default: false,
			},
			packaging_content: {
				type: String,
				required: false,
			},
			attached_file_content: {
				type: String,
				required: false,
			},
			others_content: {
				type: String,
				required: false,
			},
			source_of_transport: {
				type: String,
				required: false,
			},
			transport: {
				type: String,
				required: false,
			},
			content: {
				type: String,
				required: false,
			},
			exists_quotation_cost: {
				type: Boolean,
				required: false,
				default: false,
			},
			exists_order_amount: {
				type: Boolean,
				required: false,
				default: false,
			},
			created_user: {
				type: String,
				required: false,
			},
			file_url: {
				type: Array,
				required: false,
				default: () => [],
			},
			removefiles: {
				type: Array,
				required: false,
				default: () => [],
			},
		},
		items: {
			source_of_base_materials: {
				type: Array,
				required: false,
				default: () => [],
			},
			attached_file_items: {
				type: Array,
				required: false,
				default: () => [],
			},
			source_of_transports: {
				type: Array,
				required: false,
				default: () => [],
			},
			transports: {
				type: Array,
				required: false,
				default: () => [],
			},
		},
	},
	data() {
		return {
			rules,
			openDialog: false,
			users: [],
			userKeyword: null,
			searchUsersTimer: null,
			errorUserFlag: false,
		}
	},
	computed: {
		allFiles() {
			if (this.order_confirmation.file_url) {
				return this.order_confirmation.file_url.length
			}
		},
		userHint() {
			if (this.users.length) {
				return "社員名を選択してください"
			} else if (this.searchUsersTimer) {
				return "社員名を取得しています"
			} else if (!this.users.length && this.userKeyword) {
				return "該当する社員名が存在していません"
			} else if (this.errorUserFlag && !this.userKeyword) {
				return "選択肢から社員名を選択してください"
			} else {
				return "社員名を入力してください"
			}
		},
	},
	methods: {
		setSearchUsers(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.users = []
			this.userKeyword = e.target.value
			clearTimeout(this.searchUsersTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.userKeyword.length) return // 0文字の場合はreturn
			this.searchUsersTimer = setTimeout(this.fetchUsers, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		changeUser() {
			// テキスト追加時の削除
			if (!this.users.includes(this.order_confirmation.created_user)) {
				this.errorUserFlag = true
				this.order_confirmation.created_user = null
				this.$refs.user_combobox.reset()
			}
		},
		fetchUsers() {
			const params = {
				q: {
					last_name_or_first_name_cont: this.userKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_users", {
					headers,
					params,
				})
				.then((res) => {
					this.searchUsersTimer = null
					this.users = res.data.users
					this.errorUserrFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				if (this.order_confirmation.file_url.length) {
					const isDuplicate = this.order_confirmation.file_url.some((url) => {
						return file[1].name === url.name
					})
					if (!isDuplicate) {
						this.order_confirmation.file_url.push(file[1])
					}
				} else {
					this.order_confirmation.file_url.push(file[1])
				}
			})
		},
		removeFile(index) {
			const removeFile = this.order_confirmation.file_url[index]
			this.order_confirmation.file_url.splice(index, 1)
			this.order_confirmation.removefiles.push(removeFile)
		},
		sendParent() {
			this.$emit("submit")
		},
	},
}
</script>
